import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const UpRightArrowIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 20 20'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M14.7578 4.99219C15.1641 4.99219 15.5078 5.33594 15.5078 5.74219V13.2422C15.5078 13.6797 15.1641 13.9922 14.7578 13.9922C14.3203 13.9922 14.0078 13.6797 14.0078 13.2422V7.55469L6.78906 14.7734C6.47656 15.0859 6.00781 15.0859 5.72656 14.7734C5.41406 14.4922 5.41406 14.0234 5.72656 13.7422L12.9453 6.52344H7.25781C6.82031 6.52344 6.50781 6.17969 6.50781 5.77344C6.50781 5.33594 6.82031 5.02344 7.25781 5.02344H14.7578V4.99219Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
